import React from 'react';
import {useMeUser} from './hooks';
import {Image} from '@/components-v2/Image';
import {ReactComponent as AvatarSvg} from '@/assets/icons/me/avatar.svg';
import {ReactComponent as WhiteRightArrowIcon} from '@/assets/icons/me/white-right-arrow.svg';
import {ReactComponent as PhoneIcon} from '@/assets/icons/me/phone.svg';
import {defaultHeaderImg} from '../../me.variable';

const MeUserInfo = () => {
  const {login, user, t, toProfile} = useMeUser();
  return (
    <div className="flex flex-row gap-2 z-[1]" onClick={toProfile}>
      {login ? (
        <Image
          src={user?.avatar || defaultHeaderImg}
          className="size-10 rounded-full bg-white flex items-center justify-center"
        />
      ) : (
        <AvatarSvg className="size-10" />
      )}
      <div className="flex flex-row flex-1 items-center justify-between">
        <div className="flex flex-col gap-1 text-white justify-center">
          <span className="text-sm font-bold leading-[normal]">
            {login ? user?.userName : t('me.user.login')}
          </span>
          <span className="text-xs leading-[normal] flex flex-row items-center gap-3">
            <span>
              ID:
              {login ? (user?.userId ? +user.userId + 100000 : '-') : '******'}
            </span>
            <div className="flex flex-row items-center gap-1">
              <PhoneIcon className="size-3" />
              <span className="h-3">{login ? user?.userPhone : '******'}</span>
            </div>
          </span>
        </div>
        <WhiteRightArrowIcon className="size-4" />
      </div>
    </div>
  );
};

export default MeUserInfo;
